module.exports = __webpack_public_path__ + "static/media/Crystal_Kim.47f7b3dd.png";